import { TOUR_DRAWER, HIDE_DRAWER, VR_INSTRUCTION_DRAWER } from '../drawerMenuActions'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants'
import * as DESKTOP_EVENTS from 'aria-viewer/analytics/constants/desktopAnalytics'

const drawerAnalytics = {
    [TOUR_DRAWER]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        const properties = {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        }

        return [
            trackEvent(EVENTS.EXPERIENCENAME_CLICKED, properties),
            trackEvent(EVENTS.EXPERIENCELIST_VIEWED, properties),
        ]
    },

    [HIDE_DRAWER]: (getState, action) => {
        const drawerMenu = getState().getIn(['drawerMenu', 'name'])

        if (drawerMenu == TOUR_DRAWER) {
            const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

            return trackEvent(EVENTS.EXPERIENCELIST_CLOSED, {
                Institution: inst_name,
                Inst_ID: owner_id,
                Location: loc_name,
                Loc_ID: loc_id,
                Stop: stoptitle,
                Stop_ID: stopid,
            })
        }
    },

    [VR_INSTRUCTION_DRAWER]: (getState, action) => {
        const { inst_name, owner_id, stoptitle } = getTourData()(getState)

        return trackEvent(DESKTOP_EVENTS.MOREICON_VIEWINVR_CLICKED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Scene_Name: stoptitle,
        })
    },
}

export default drawerAnalytics
